import { render, staticRenderFns } from "./CreateITRQ.vue?vue&type=template&id=086da674&scoped=true&"
import script from "./CreateITRQ.vue?vue&type=script&lang=ts&"
export * from "./CreateITRQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086da674",
  null
  
)

export default component.exports